import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_checked = _resolveComponent("checked")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_star = _resolveComponent("star")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_app_biddings_list = _resolveComponent("app-biddings-list")!
  const _component_app_loader_biddings = _resolveComponent("app-loader-biddings")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: "" }, {
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { "nav-title": "" }, "Bidding", -1)
        ]))]),
        right: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-search"
              }))
            : _createCommentVNode("", true)
        ]),
        bottom: _withCtx(() => [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.activeIndex,
            router: "",
            mode: "horizontal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/biddings" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_checked)
                    ]),
                    _: 1
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "All", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/biddings?status=ongoing" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_star)
                    ]),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "Awaiting", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/biddings?status=accepted" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_star)
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Accepted", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/biddings?status=rejected" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_star)
                    ]),
                    _: 1
                  }),
                  _cache[4] || (_cache[4] = _createElementVNode("span", null, "Denied", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_app_biddings_list, { biddings: _ctx.biddings }, null, 8, ["biddings"]),
        _createVNode(_component_app_loader_biddings, {
          loading: _ctx.loading,
          resources: _ctx.biddings
        }, null, 8, ["loading", "resources"])
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_app_business_right_nav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}